import CheckboxCell from '../../../../common/interactive/CheckboxCell'
import DatepickerWithLabel from '../../../../common/interactive/DatepickerWithLabel'
import classes from '../SurgicalDrawer.module.css'
import PreoperativeTestsRepeater from '../preoperativeTests/PreoperativeTestsRepeater'

export default function PreoperativeTests({itemData, updateHandler, apiCase}) {

    const itemsBuild = [
        {
            field: "step_6_pre_operative",
            label: 'PreOperative (H&P)'
        },
        {
            field: "step_6_ekg",
            label: 'EKG'
        },
        {
            field: "step_6_labs",
            label: 'LABS'
        },        
        {
            field: "step_6_medical_clearance",
            label: 'Medical Clearance',
            isRepeater: true
        },
        {
            field: "step_6_cardiac_clearance",
            label: 'Cardiac Clearance',
            isRepeater: true
        },
        {
            field: "step_6_chest_xray",
            label: 'Chest Xray'
        },
        {
            field: "step_6_other_xrays",
            label: 'Other Xray'
        },
        {
            field: "step_6_updated_mri",
            label: 'Updated MRI'
        },
        {
            field: "step_6_discogram",
            label: 'Discogram'
        },
        {
            field: "step_6_emg_ncv",
            label: 'EMG/NCV'
        }
    ]
    
    return <div className={classes.drawer_pannel}>
        <h3 className={`${classes.pannel_title} ${classes.pannel_title_cells}`}>
            <span>#6 Preoperative Test</span>
            <span>Requested</span>
            <span className={classes.pannel_title_cell_small}>Obtained/Completed</span>
            {/* <span className={classes.pannel_title_cell_small}>Completed Date</span> */}
        </h3>


        {itemsBuild.map(item => (
            <div key={item.field} className={classes.drawer_row} >
                <div className={`${classes.drawer_flex_block} ${classes.drawer_flex_block_spred}`} style={{minHeight: `var(--field-normal-height)`}}>
                    <CheckboxCell label={item.label} action={updateHandler} checked={itemData[item.field]} direction={'reverse'} identifier={{folder: 'surgeries', type: apiCase, field: item.field, type_id: itemData.id, clear_data:true}}/>
                    {!item.isRepeater ? <>
                        <div className='flex-container' style={{width: 140}}>
                            {itemData[item.field] ? <>
                                <CheckboxCell  action={updateHandler} checked={itemData[`${item.field}_requested`]} direction={'centered'} identifier={{folder: 'surgeries', type: apiCase, field: `${item.field}_requested`, type_id: itemData.id, extra: 'date'}}/>
                                <DatepickerWithLabel textRight={true} label={''} defaultDate={itemData[`${item.field}_requested_date`]} setStyle={'simple'} action={updateHandler} identifier={{folder: 'surgeries', type: apiCase, field: `${item.field}_requested_date`, type_id: itemData.id}}/>
                            </> : ''}                    
                            
                        </div>
                        <div className='flex-container' style={{width: 140}}>
                            {itemData[item.field] ? <>
                                <CheckboxCell  action={updateHandler} checked={itemData[`${item.field}_obtained`]} direction={'centered'} identifier={{folder: 'surgeries', type: apiCase, field: `${item.field}_obtained`, type_id: itemData.id, extra: 'date'}}/>
                                <DatepickerWithLabel textRight={true} label={''} defaultDate={itemData[`${item.field}_obtained_date`]} setStyle={'simple'} action={updateHandler} identifier={{folder: 'surgeries', type: apiCase, field: `${item.field}_obtained_date`, type_id: itemData.id}}/>
                            </> : ''}                    
                            
                        </div>
                    </> : ''
                    }
                </div>
                <>
                    {item.isRepeater && itemData[item.field] ? <PreoperativeTestsRepeater itemData={itemData} apiCase={apiCase} field={item.field + '_tests'}/> : ''}
                </>
            </div>
        ))}           

        <div className={classes.drawer_row}>
            <div style={itemData.step_6_not_cleared_for_surgery ? {color: '#d22', fontWeight: 700} : undefined}>
                <CheckboxCell label={'Not Cleared for Surgery'} action={updateHandler} checked={itemData.step_6_not_cleared_for_surgery} direction={'reverse'} identifier={{folder: 'surgeries', type: apiCase, field: 'step_6_not_cleared_for_surgery', type_id: itemData.id}}/>
            </div>
        </div>


    </div>
}